module.exports = __webpack_public_path__ + "static/1-181146b99410aad4c72d9493b6526add.jpg";